import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { LanguageService } from 'src/app/shared/services/language.service';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'language-selector',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
})
export class LanguageSelectorComponent implements OnInit {
  @Output() closeLanguageSelector = new EventEmitter<boolean>();
  isEnglish = false;
  isSpanish = false;

  constructor(private languageService: LanguageService) {}

  ngOnInit(): void {
    this.getSelectedLanguage();
  }

  changeLanguage(language: string) {
    this.languageService.setSelectedLanguage(language);
    this.getSelectedLanguage();

    //close language selector
    this.closeLanguageSelector.emit(true);
  }

  getSelectedLanguage() {
    const language = this.languageService.currentLanguage;
    switch (language) {
      case 'en':
        this.isEnglish = true;
        this.isSpanish = false;
        break;
      case 'es':
        this.isSpanish = true;
        this.isEnglish = false;
        break;
      default:
        break;
    }
  }
}
